import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  margin-left: 16px;\n  height: 100%;\n  padding: 0;\n  width: 20px;\n  background-color: transparent;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-basis: 100%;\n  justify-content: end;\n  height: 100%;\n  align-items: center;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  flex-basis: 100%;\n  height: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 76px;\n  flex-basis: 100%;\n  height: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([" \n  color: ", ";\n  font-weight; 600;\n  font-size: 14px;\n  line-height: 16px;\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.6;\n  font-size: 12px;\n  color: ", ";\n  font-weight: 500;\n  line0-height: 22px;\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  white-space: nowrap;\n  position: relative;\n  align-items: center;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  border: 0;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  background-color: transparent;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  top: 70px;\n  height: 104px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  transition: height 0.1s;\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n  @media screen and (min-width: ", "px) {\n    top: 80px;\n  }\n  @media screen and (min-width: ", "px) {\n    ", "\n  }\n\n  @media screen and (max-width: ", "px) {\n    background-color: transparent;\n    transition: background-color 500ms linear, box-shadow 0.3s ease-in-out;\n    top: ", "px;\n    ", "\n    ", "\n      ", "\n    ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  height: 70px;\n  justify-content: space-between;\n  left: 0;\n  position: absolute;\n  top: 70px;\n  width: 100%;\n  z-index: 25;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { theme } from '../theme';
import { useScrollHeight } from './hooks';
var Container = styled.div(_templateObject());
var MobileActionContainer = styled.div(_templateObject2());
var Content = styled.div(_templateObject3(), theme.breakpoints.md + 1, theme.breakpoints.sm + 1, function (props) {
  return props.sticky && "\n      height: ".concat(104 - (104 - props.stickyHeight) * props.scrollPercent, "px;\n      position: fixed;\n      z-index: 20;\n    ");
}, theme.breakpoints.sm, function (props) {
  return props.top || 69;
}, function (props) {
  return props.scrollPercent >= 0.1 && !(props.scrollHeight >= props.verticalScrollHeight) && 'box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04);';
}, function (props) {
  return props.scrollPercent >= 0.1 && "background-color: ".concat(props.invertedStripColor, ";");
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "\n        box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04); \n        background-color: ".concat(props.invertedStripTransitionColor, ";");
}, function (props) {
  return props.sticky && "\n      z-index: 20; \n      height: 66px;\n      position: fixed;\n      ";
});
var MobileButton = styled.button(_templateObject4());
var Title = styled.div(_templateObject5(), function (props) {
  return props.verticalSubText && "\n    flex-direction: column;\n    ";
});
var Subtext = styled.span(_templateObject6(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(props.theme.colors.slate);
});
var TitleText = styled.span(_templateObject7(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(props.theme.colors.slate);
});
var BackContainer = styled.div(_templateObject8());
var TitleContainer = styled.div(_templateObject9());
var ChildrenContainer = styled.div(_templateObject10());
var Button = styled.button(_templateObject11());

var A4_InvertedStrip = function A4_InvertedStrip(props) {
  var _useScrollHeight = useScrollHeight({
    scrollDistance: 64
  }),
      scrollHeight = _useScrollHeight.scrollHeight;

  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/React.createElement(Content, {
    invertedStripTransitionColor: props.invertedStripTransitionColor,
    invertedStripColor: props.invertedStripColor,
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight,
    scrollPercent: props.scrollPercent,
    sticky: true,
    stickyHeight: props.stickyHeight
  }, /*#__PURE__*/React.createElement(BackContainer, null, props.showBack && /*#__PURE__*/React.createElement(Button, {
    className: props.className,
    onClick: props.onBack
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    height: '16px',
    width: '16px',
    icon: scrollHeight <= props.verticalScrollHeight ? props.icon || AcornsIcon.Icon.ArrowLeft : props.invertedScrollIcon || AcornsIcon.Icon.ArrowBack
  }))), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, {
    verticalSubText: props.verticalSubText
  }, props.scrollPercent >= 0.1 && /*#__PURE__*/React.createElement(React.Fragment, null, props.title && /*#__PURE__*/React.createElement(TitleText, {
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight
  }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtext, {
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight
  }, props.subtext)))), /*#__PURE__*/React.createElement(ChildrenContainer, null, props.invertedChildrenIcons && props.invertedChildrenIconsScrolled ? /*#__PURE__*/React.createElement(React.Fragment, null, scrollHeight <= props.verticalScrollHeight ? props.invertedChildrenIcons.map(function (child) {
    return /*#__PURE__*/React.createElement(MobileActionContainer, null, /*#__PURE__*/React.createElement(MobileButton, {
      onClick: child.action
    }, child.icon));
  }) : props.invertedChildrenIconsScrolled.map(function (child) {
    return /*#__PURE__*/React.createElement(MobileActionContainer, null, /*#__PURE__*/React.createElement(MobileButton, {
      onClick: child.action
    }, child.icon));
  })) : props.children)));
};

export { A4_InvertedStrip };